import { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    TextField,
    Button,
    Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { BIBlue, BIGrey } from "../../assets/helpers";
import { English } from "../../constant/EnglishFallback";
import { useSelector } from "react-redux";

export default function PostalCodeDialogue(props) {
    const { postalCodePopup, setPostalCodePopup, setPostalCodeText, getNearbyCarpoolersList } = props;
    const [postalCode, setPostalCode] = useState("");
    const { multiLanguageData } = useSelector((state) => state?.main);
    const postalCodeRegex = /^(?:(?:[A-Z]{1,2}[0-9R][0-9A-Z]?[0-9][A-BD-HJLNP-UW-Z]{2})|(?:[0-9]{5}(?:-[0-9]{4})?)|(?:[A-Z][0-9][A-Z]\s?[0-9][A-Z][0-9])|(?:[0-9]{4,6})|(?:[A-Z0-9]{2,10}))$/i;

    const LanguageData = multiLanguageData?.PostalCodeDialogue || {};
    const {
        TEXT_LOCATION = English?.PostalCodeDialogue?.TEXT_LOCATION,
        TEXT_ENTER_POSTAL_CODE = English?.PostalCodeDialogue?.TEXT_ENTER_POSTAL_CODE,
        BUTTON_APPLY = English?.PostalCodeDialogue?.BUTTON_APPLY,
    } = LanguageData || {};

    const handleClose = () => {
        setPostalCode("");
        setPostalCodePopup(false);
    };

    const handleApply = () => {
        setPostalCodeText(postalCode);
        getNearbyCarpoolersList(postalCode);
        handleClose();
    };

    const isPostalCodeValid = postalCodeRegex.test(postalCode);

    return (
        <div>
            <Dialog
                open={postalCodePopup}
                onClose={handleClose}
                maxWidth="xs"
                sx={{
                    "& .MuiPaper-root": {
                        borderRadius: 3,
                    },
                }}
                fullWidth
            >
                <DialogTitle sx={{ m: 0, p: 2 }}>
                    <Typography variant="subtitle1" fontWeight="bold" ml={1}>
                        {TEXT_LOCATION}
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ textAlign: "center" }}>
                    <TextField
                        fullWidth
                        placeholder={TEXT_ENTER_POSTAL_CODE}
                        variant="outlined"
                        size="small"
                        value={postalCode}
                        onChange={(e) => setPostalCode(e.target.value)}
                        sx={{ mt: 1, mb: 2 }}
                    />

                    <Button
                        onClick={handleApply}
                        disabled={!isPostalCodeValid}
                        sx={{
                            color: isPostalCodeValid ? BIBlue : BIGrey,
                            fontWeight: 500
                        }}
                    >
                        {BUTTON_APPLY}
                    </Button>
                </DialogContent>
            </Dialog>
        </div>
    );
}
